


import Inview             from './classes/Inview';
import Pluton             from 'whitecube-pluton';

class Fondation {
    constructor() {
        this.parts = new Pluton();
        this.inview = Inview;

        this.setEvents();
    }

    setEvents() {
        window.addEventListener("pluton-setup", this.e_plutonSetup.bind(this))
    }

    e_plutonSetup(e) {
        console.log('pluton-setup', e.detail.el);
        this.parts.setup(e.detail.el);
    }
}

window.addEventListener("load", function(event) {
    window.Fondation = new Fondation();
});

window.initMap = () => {
    window.dispatchEvent(new CustomEvent('fondation-mapsloaded'));
    window.mapsLoaded = true;
}

window.onYouTubeIframeAPIReady = () => {
    window.dispatchEvent(new CustomEvent('fondation-youtubeloaded'));
    window.youtubeLoaded = true;
}